import React from 'react';
import Modal from './Modal';
import FormsySimpleInput from '../form/FormsySimpleInput';
import Formsy from 'formsy-react';
import FilterBar from './FilterBar';
import ActiveFilters from './ActiveFilters';
import { menuAPI } from '../../InterfaceAPI/menuAPI';
import { parseFilters } from '../../helpers/util';
import Pagination from '../shared/Pagination';

class AddDishModal extends React.Component {
  state = {
    lastTerm: '',
    searchTerm: '',
    isLoading: false,
    pagination: {},
    availableFilters: {
      dietary_preference_tags: {
        label: 'Diet',
        type: 'checkbox',
        prop: 'tag',
        options: []
      },
      allergens: {
        label: 'Allergens',
        prefix: 'No ',
        type: 'checkbox',
        prop: 'tag',
        options: []
      },
      seasonality_tags: {
        label: 'Seasonality',
        type: 'checkbox',
        prop: 'tag',
        options: []
      },
      cuisine: {
        label: 'Cuisine',
        type: 'checkbox',
        prop: 'name',
        options: []
      },
      category: {
        label: 'Categories',
        type: 'checkbox',
        prop: 'name',
        options: []
      },
      complexity: {
        label: 'Complexity',
        type: 'radio',
        prop: 'label',
        options: [
          { id: "basic", label: "Basic"},
          { id: "simple", label: "Simple"},
          { id: "moderate", label: "Moderate"},
          { id: "intensive", label: "Intensive"}
        ]
      },
      format: {
        label: 'Format',
        type: 'checkbox',
        prop: 'label',
        options: [
          { id: "is_weekly", label: "Weekly Dish"},
          { id: "is_special_occasion", label: "Special Occasions Dish"},
          { id: "is_large_party", label: "Large Party"}
        ]
      }
    },
    activeFilters: [],
    dishes: []
  };

  render() {
    const { handleSearch, loadDishes, toggleFilter, swapFilter } = this;
    const { isOpen, closeModal } = this.props;
    const {
      searchTerm,
      activeFilters,
      availableFilters,
      pagination
    } = this.state;
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        className="modal modal--no-padding modal--wide admin-wrapper"
      >
        <div className="modal__head modal__head--flush-bottom">
          <h2 className="h2 modal__heading">Add a Dish</h2>
          <Formsy className="form" onValidSubmit={loadDishes}>
            <div className="cms__bar cms__bar--margin-bot">
              <div className="cms__bar-item cms__bar-item--full">
                <FormsySimpleInput
                  type="text"
                  name="searchTerm"
                  placeholder="Enter Dish Name"
                  className="simple-input simple-input--pad-right"
                  value={searchTerm}
                  onChange={handleSearch}
                  autoComplete="off"
                />
              </div>
              <div className="cms__bar-item">
                <input
                  type="submit"
                  value="Search"
                  className="btn btn--solid-blue"
                />
              </div>
            </div>
          </Formsy>
          <FilterBar
            activeFilters={activeFilters}
            availableFilters={availableFilters}
            toggleFilter={toggleFilter}
            swapFilter={swapFilter}
            includeFormsy="true"
          />
        </div>
        <div className="modal__body modal__body--tall">
          <ActiveFilters
            activeFilters={activeFilters}
            toggleFilter={toggleFilter}
          />
          <div className="add-dish">{this.renderDishes()}</div>
          <div className="cms__pagination">
            <Pagination
              pageCount={pagination.total_pages || 1}
              forcePage={pagination.current_page - 1 || 0}
              onPageChange={this.handlePaginate}
            />
          </div>
        </div>
      </Modal>
    );
  }

  renderDishes() {
    const { dishes, lastTerm, pagination } = this.state;
    if (dishes.length === 0)
      return (
        <div className="add-dish__results dish__results--empty">
          <p className="p">
            Enter a dish name or select filters to see results to add to the
            menu.
          </p>
        </div>
      );
    else
      return (
        <div className="add-dish__results">
          <div className="add-dish__results-count">
            <span className="p p--bold">{pagination.total_items} Results </span>
            {lastTerm !== '' ? `for "${lastTerm}"` : ''}
          </div>
          <div className="add-dish__list">
            {dishes.map(dish => this.renderDish(dish))}
          </div>
        </div>
      );
  }

  renderDish(dish) {
    return (
      <div
        key={dish.id}
        className="add-dish__item"
        onClick={() => this.props.addDish(dish)}
      >
        {dish.name}{' '}
        <span className="p--em p--new-line">{dish.child_name || ''}</span>
      </div>
    );
  }

  toggleFilter = newFilter => {
    const activeFilters = [...this.state.activeFilters];
    const i = activeFilters.findIndex(filter => filter.key === newFilter.key);
    if (i >= 0) activeFilters.splice(i, 1);
    else activeFilters.push(newFilter);

    this.setState({ activeFilters }, this.loadDishes);
  };

  swapFilter = newFilter => {
    const activeFilters = [...this.state.activeFilters];

    // same key? delete
    const x = activeFilters.findIndex(filter => filter.key === newFilter.key);
    if (x >= 0) activeFilters.splice(x, 1);
    else {
      // dif key? delete + add
      const i = activeFilters.findIndex(
        filter => filter.type === newFilter.type
      );
      if (i >= 0) activeFilters.splice(i, 1);

      // add
      activeFilters.push(newFilter);
    }

    this.setState({ activeFilters }, this.loadDishes);
  };

  handleSearch = e => {
    this.setState({ searchTerm: e.target.value });
  };

  loadDishes = (page = 1) => {
    const { searchTerm: name } = this.state;
    const search = parseFilters(this.state.activeFilters);
    search.name = name;
    // clear existing
    this.setState({ dishes: [], isLoading: true });

    // make request
    menuAPI
      .searchDishes({ page, sort: [], search })
      .then(({ dishes, pagination }) =>
        this.setState({ dishes, pagination, isLoading: false, lastTerm: name })
      )
      .catch(error => console.log(error));
  };

  componentDidMount() {
    menuAPI
      .getDiets()
      .then(({ dietary_preference_tags: options }) => {
        const availableFilters = { ...this.state.availableFilters };
        availableFilters.dietary_preference_tags.options = options;
        this.setState({ availableFilters });
      })
      .catch(error => console.log(error));

    menuAPI
      .getSeasonality()
      .then(({ seasonality_tags: options }) => {
        const availableFilters = { ...this.state.availableFilters };
        availableFilters.seasonality_tags.options = options;
        this.setState({ availableFilters });
      })
      .catch(error => console.log(error));

    menuAPI
      .getCuisines()
      .then(({ cuisines: options }) => {
        const availableFilters = { ...this.state.availableFilters };
        availableFilters.cuisine.options = options;
        this.setState({ availableFilters });
      })
      .catch(error => console.log(error));

    menuAPI
      .getCategories()
      .then(({ dish_categories }) => {
        const options = dish_categories
        const availableFilters = { ...this.state.availableFilters };
        availableFilters.category.options = options;
        this.setState({ availableFilters });
      })
      .catch(error => console.log(error));

    menuAPI
      .getAllergens()
      .then(({ allergen_tags: options }) => {
        const availableFilters = { ...this.state.availableFilters };
        availableFilters.allergens.options = options;
        this.setState({ availableFilters });
      })
      .catch(error => console.log(error));
  }

  handlePaginate = ({ selected: page }) => this.loadDishes(page + 1);
}

export default AddDishModal;



// WEBPACK FOOTER //
// ./src/components/shared/AddDishModal.js